var React = require('react');

function Slash (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"40","cy":"40","r":"40","fill":"#F6F2FD","key":0}),React.createElement("path",{"d":"M29.5 30L19 40.5L29.5 51","stroke":"#8139F5","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M50.5 51L61 40.5L50.5 30","stroke":"#8139F5","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M44.5 25L35.5 56","stroke":"#8139F5","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Slash.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = Slash;

Slash.default = Slash;
